import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'

Vue.use(Vue2Filters)



// HAND MADE FILTERS
Vue.filter('humanizar_fecha', (value) => {
	moment.locale('es');
	// return moment(value).format("dddd D [de] MMMM");
	return moment(value).format("dddd D [de] MMMM [del] YYYY, h:mm:ss a");
});

/** 
 * Minutes to time, requires Momemnt 2.9 or better
 */
 
Vue.filter('minutes_to_time', (value) => {
	moment.locale('es');
	let start = moment();
	start.set({'month': 1, 'day': 1, 'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
	return start.add(value, 'm').format("HH:mm");
});

Vue.filter('humanizar_fecha_simple', (value) => {
	moment.locale('es');
	// return moment(value).format("dddd D [de] MMMM");
	return moment(value).format("dddd D MMM YYYY");
});

const translate = (value) => {
	if (typeof value !== 'string') return value;
	const matrix = [
		{value: 'calificacion', label: 'Calificación'},
	]
	const found = matrix.find(m => m.value === value.toLowerCase().trim());
	console.log('i.found', found, value)
	return (found && found.label)?found.label: value;
};

Vue.filter('i', translate);
Vue.filter('translate', translate);

Vue.filter('makeClass', (value) => {
	if (typeof value !== 'string') return value;
	// Remove first character if it's a number
	let cleaned = value.replace(/^\d/, '');
	// Convert to kebab-case
	return cleaned
		.replace(/([a-z])([A-Z])/g, '$1-$2')
		.replace(/[\s_]+/g, '-')
		.toLowerCase();
});

Vue.filter('supereasyEstatus', (value) => { 
	let matrix = {
		1: "Registrado",
		2: "En proceso",
		3: "Armado", 
		4: "Entregado",
		6: "Cancelado"
	}
	return matrix[value]
});

Vue.filter('humanizar_diferencia', (value) => {
	moment.locale('es');
	let string = moment(value).fromNow()
	switch(string){
		case 'en unos segundos':
			return "Justo ahora"
			break;
		default:
			return string
			break;
	}
});

Vue.filter('solo_hora', (value) => {
	moment.locale('es');
	return moment(value).format("h:mm a");
});